import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Chip,
    Divider,
    Paper,
} from "@mui/material";
import { Data } from "./tableHeadCells";

interface LogDetailModalProps {
    open: boolean;
    onClose: () => void;
    log: Data | null;
}

const LogDetailModal: React.FC<LogDetailModalProps> = ({ open, onClose, log }) => {
    if (!log) return null;

    const formatJson = (jsonString: string) => {
        try {
            const parsed = JSON.parse(jsonString);
            return JSON.stringify(parsed, null, 2);
        } catch {
            return jsonString;
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="h6">Log Details</Typography>
                    <Chip label={`ID: ${log.id}`} size="small" />
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {/* Basic Information */}
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            Basic Information
                        </Typography>
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    User
                                </Typography>
                                <Typography variant="body1">{log.user}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Action
                                </Typography>
                                <Chip label={log.action} size="small" />
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Entity
                                </Typography>
                                <Typography variant="body1">{log.entity}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Entity ID
                                </Typography>
                                <Typography variant="body1">{log.entityId}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Method
                                </Typography>
                                <Chip label={log.method} size="small" />
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Status Code
                                </Typography>
                                <Chip label={log.statusCode} size="small" />
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    IP Address
                                </Typography>
                                <Typography variant="body1">{log.ipAddress}</Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary">
                                    Date & Time
                                </Typography>
                                <Typography variant="body1">{log.createdAt}</Typography>
                            </Box>
                        </Box>
                    </Paper>

                    <Divider />

                    {/* Request Body */}
                    {log.requestBody && (
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                Request Body
                            </Typography>
                            <Box
                                component="pre"
                                sx={{
                                    // backgroundColor: "#f5f5f5",
                                    p: 2,
                                    borderRadius: 1,
                                    overflow: "auto",
                                    maxHeight: "200px",
                                    fontSize: "0.875rem",
                                }}
                            >
                                {formatJson(log.requestBody)}
                            </Box>
                        </Paper>
                    )}

                    {/* Response Body */}
                    {log.responseBody && (
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                Response Body
                            </Typography>
                            <Box
                                component="pre"
                                sx={{
                                    // backgroundColor: "#f5f5f5",
                                    p: 2,
                                    borderRadius: 1,
                                    overflow: "auto",
                                    maxHeight: "200px",
                                    fontSize: "0.875rem",
                                }}
                            >
                                {formatJson(log.responseBody)}
                            </Box>
                        </Paper>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogDetailModal;
